module.exports = __webpack_public_path__ + "2772644f91a695d7070075adce601b02.png";